import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'mwp-placeholder-card',
    templateUrl: './card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PlaceHolderCardComponent {
    public cssClassWave: string = 'placeholder-wave';
    public cssClassGlow: string = 'placeholder-glow';
}